module.exports = __webpack_public_path__ + "static/media/about2.4b954e58.jpg";